import './export-button.css';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import svg from '../../assets/export-icon.svg';
import React from 'react';

interface ExportButtonDatamodel {
  onClick: () => void;
}

const ExportButton: React.FC<ExportButtonDatamodel> = ({ onClick }) => {
  return (
    <div onClick={onClick} className={'export-button'}>
      <div style={{ fontWeight: '14px' }}>יצוא לטבלה</div>
      <img src={svg} />
    </div>
  );
};

export default ExportButton;
